import { render, staticRenderFns } from "./ButtonGroups.vue?vue&type=template&id=6124a130&"
import script from "./ButtonGroups.vue?vue&type=script&lang=js&"
export * from "./ButtonGroups.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports